'use client';

import { motion } from "framer-motion";

export default function TypingAnimation() {
  const dotVariants = {
    initial: {
      y: "0%",
    },
    animate: {
      y: ["0%", "100%", "0%"],
    },
  };

  const containerVariants = {
      initial: {
          opacity: 0,
      },
      animate: {
          opacity: 1,
          transition: {
              staggerChildren: 0.2,
          },
      },
  };

  return (
    <motion.div
        variants={containerVariants}
        initial="initial"
        animate="animate"
        className="flex h-10 w-fit items-center justify-center gap-1.5 rounded-xl bg-[#E9F8FA] px-4 py-3"
    >
      <motion.span
        className="block h-2 w-2 rounded-full bg-[#1E2D3A]/50"
        variants={dotVariants}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.span
        className="block h-2 w-2 rounded-full bg-[#1E2D3A]/50"
        variants={dotVariants}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
      />
      <motion.span
        className="block h-2 w-2 rounded-full bg-[#1E2D3A]/50"
        variants={dotVariants}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
      />
    </motion.div>
  );
};
